module.exports = __webpack_public_path__ + "e2d1904e7f06d8c9dc38a91aa701fe26.jpg";